import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// Refresh Token Thunk
export const refreshToken = createAsyncThunk(
  "auth/refreshToken",
  async (_, thunkAPI) => {
    try {
      const apiClient = new APIClient();
      const refreshToken = JSON.parse(sessionStorage.getItem("authUser")).data.refreshToken;
      const response = await apiClient.put("/api/v1/authentication/refresh-token", { token: refreshToken });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: JSON.parse(sessionStorage.getItem("authUser")),
    loading: false,
    error: null,
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      sessionStorage.setItem("authUser", JSON.stringify(action.payload));
    },
    clearUser(state) {
      state.user = null;
      sessionStorage.removeItem("authUser");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.loading = false;
        state.user = { ...state.user, data: action.payload };
        sessionStorage.setItem("authUser", JSON.stringify(state.user));
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.user = null;
        sessionStorage.removeItem("authUser");
      });
  },
});

export const { setUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
